interface IAndroidWindow {
	TokenProvider: {
		getAccessToken(callback: 'onGetAndroidTokenHandler', identifier: string): void;
	};
	onGetAndroidTokenHandler: (token: string, identifier: string) => void;
}

const win = (window as any) as IAndroidWindow;
let requestsChainIt = 0;
const requestsChain: { [key: string]: (token: string) => void } = {};

win.onGetAndroidTokenHandler = (token, identifier) => {
	requestsChain[identifier](token);
	delete requestsChain[identifier];
};

export function getAuthTokenAndoid(onRecieveToken: (token: string) => void) {
	requestsChainIt += 1;
	requestsChain[requestsChainIt] = onRecieveToken;
	// use the identifier for make sure the correct callback is executed
	win.TokenProvider.getAccessToken('onGetAndroidTokenHandler', requestsChainIt.toString());
}
